<template>
  <a v-translate
     :class="dismissBtnClasses"
     @click.stop="handleDismissBtnClick()">
    Dismiss
  </a>
</template>

<script>
export default {
  props: {
    recommendedJobId: String
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    dismissBtnClasses() {
      return ['button button-dismiss is-default small', {'is-loading': this.loading}];
    }
  },
  methods: {
    toogleLoading() {
      this.loading = !this.loading;
    },
    handleDismissBtnClick() {
      this.toogleLoading();
      this.$store
        .dispatch('dismissRecommendedJobActionByTime', {id: this.recommendedJobId})
        .then(() => this.toogleLoading());
    }
  }
};
</script>

<style lang="scss" scoped>
.button-dismiss {
  min-width: 100px;
}
</style>
